<div class="row" *ngIf="taxStrategy">
  <div class="small-12 medium-12 columns" style="color: #344054;font-size: 14px;font-weight: 500;">
    Accountant's Checklist
  </div>
  <div class="small-12 medium-12 columns">
    <div class="row row-margin">
      <div class="small-12 medium-12 columns">
        <label class="strategy-view-label">Setup</label>
      </div>
    </div>
    <div class="row row-margin" *ngIf="checklist && checklist.length > 0">
      <div class="small-11 medium-11 columns strategy-view-content tp-list-item-box" *ngFor="let value of checklist;let i = index">
        <div class="tp-list-item-title">{{value.name}}</div>
        <div class="tp-list-item-desc" [innerHTML]="value.description"></div>
      </div>
    </div>
    <div class="row" *ngIf="!checklist || checklist.length == 0">
      <div class="small-12 medium-12 columns strategy-view-content">
        No Setup type checklist configured for this strategy.
      </div>
    </div>
    <div class="row row-margin">
      <div class="small-12 medium-12 columns">
        <label class="strategy-view-label">Recurring</label>
      </div>
    </div>
    <div class="row" *ngIf="recurringChecklists && recurringChecklists.length > 0">
      <div class="small-12 medium-11 columns strategy-view-content tp-list-item-box" *ngFor="let value of recurringChecklists;let i = index">
        <div class="tp-list-item-title">{{value.name}}</div>
        <div class="tp-list-item-desc" [innerHTML]="value.description"></div>
      </div>
    </div>
    <div class="row" *ngIf="!recurringChecklists || recurringChecklists.length == 0">
      <div class="small-12 medium-12 columns strategy-view-content">
        No Recurring type checklist configured for this strategy.
      </div>
    </div>

    <div class="row row-margin">
      <div class="small-12 medium-12 columns">
        <label class="strategy-view-label">Client To-Do's</label>
      </div>
    </div>
    <div class="row" *ngIf="!taxStrategy.clientTodos || taxStrategy.clientTodos.length === 0">
      <div class="small-12 medium-12 columns strategy-view-content">
        No to do's available.
      </div>
    </div>
    <div class="row" *ngIf="taxStrategy.clientTodos && taxStrategy.clientTodos.length > 0">
      <div class="small-12 medium-11 columns strategy-view-content tp-list-item-box" *ngFor="let todo of taxStrategy.clientTodos">
        <div class="tp-list-item-title">{{todo.name}}</div>
        <div class="tp-list-item-desc">
          <app-tpiq-froala-view [data]="todo.description"></app-tpiq-froala-view>
        </div>
      </div>
    </div>

    <div class="row row-margin">
      <div class="small-12 medium-12 columns">
        <label class="strategy-view-label">Firm's Customization</label>
      </div>
    </div>

    <div class="row row-margin">
      <div class="small-12 medium-12 columns">
        <label class="strategy-view-label">Content</label>
        <div class="strategy-view-content" *ngIf="!taxStrategy.firmCustomizations.content">No content available.</div>
        <div class="strategy-view-content" *ngIf="taxStrategy.firmCustomizations.content">
          <app-tpiq-froala-view [data]="taxStrategy.firmCustomizations.content"></app-tpiq-froala-view>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="small-12 medium-12 columns">
        <label class="strategy-view-label">Files</label>
      </div>
      <div class="small-12 medium-12 columns strategy-view-content" *ngIf="taxStrategy.firmCustomizations.files.length == 0">
        No files available.
      </div>
      <div class="small-12 medium-12 columns" *ngIf="taxStrategy.firmCustomizations.files.length > 0">
        <div class="row">
          <div class="medium-5 columns" *ngFor="let file of taxStrategy.firmCustomizations.files; let i=index;">
            <div class="row tp-file-item-box" >
              <div class="medium-8 pointer file-font" title="{{file.name}}">
                <div class="tp-file-item-name">{{file.name}}</div>
              </div>
              <div class="column medium-4 post-icons">
                <i class="icon ion-ios-cloud-download-outline float-right post-icons-pad" (click)="getFileData(file)"></i>
              </div>
              <div class="small-12 medium-12 columns" *ngIf="file.fileType == 'image'">
                <div class="row" style="padding: 0px;margin-left: 0px">
                  <img class="image-zoom" [src]="file.temporaryURL"/>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</div>

